module.exports = __webpack_public_path__ + "img/check.9509f75e.svg";